import React, { useReducer, useContext, useEffect } from "react";
import MUIDataTable from "mui-datatables";
import { useSelector, useDispatch } from "react-redux";
import { Formik, Form, 
  // useFormikContext
 } from "formik";
import * as Yup from "yup";

// MUI imports
import { Button, Grid } from "@mui/material";

// Project imports

import { saveFormDataPartTwo } from "../../../Actions";

import { TrainingCentreRegContext } from "../helperFunctions";

import TextFieldTR from "../FormComponents/TextFieldTR";
import SelectTR from "../FormComponents/SelectTR";
import ButtonTR from "../FormComponents/ButtonTR";

const initialState = {
  equipments: [],
  clearFormValues: false,
};

const INITIAL_STATE = {
  // controlled form values
  skillId: "",
  equipmentName: "",
  equipmentUnits: "",
  remark: "",
};

const formValidationSchema = Yup.object().shape({
  skillId: Yup.string().required("This is a required field"),
  equipmentName: Yup.string().required("This is a required field"),
  equipmentUnits: Yup.number()
    .integer()
    .required("This is a required field")
    .typeError("Please enter a valid number"),
  remark: Yup.string().required("This is a required field"),
});

const reducer = (state, action) => {
  /* dispatch body convention -->> { type: [string], body: [action specific object] } */

  switch (action.type) {
    case "changedSkillArea": {
      return {
        ...state,
        skillId: action.body,
      };
    }
    case "changedEquipmentName": {
      return {
        ...state,
        equipmentName: action.body,
      };
    }
    case "changedEquipmentUnits": {
      return {
        ...state,
        equipmentUnits: action.body,
      };
    }
    case "changedRemark": {
      return {
        ...state,
        remark: action.body,
      };
    }
    case "addedTrainingEquipmentInfo": {
      let curTrainingEquipmentInfo = state.equipments;
      
      curTrainingEquipmentInfo.push({
        skillId: action.body.skillId,
        equipmentUnits: action.body.equipmentUnits,
        equipmentName: action.body.equipmentName,
        remark: action.body.remark,
      });

      return {
        ...state,
        equipments: curTrainingEquipmentInfo,
        clearFormValues: true,
      };
    }
    case "deletedTrainingEquipmentInfo": {
      const curEquipmentList = state.equipments;
      const elId = action.body;
      const newEquipmentList = curEquipmentList.toSpliced(elId, 1)

      return {
        ...state,
        equipments: newEquipmentList,
      };
    }
    case "reset": {
      return {
        ...state,
        clearFormValues: false,
      }
    }
    case "syncLocalStore": {
      return {
        ...state,
        ...action.body,
      };
    }
    default:
      return {
        ...state,
      };
  }
};

// React component that watches for the add training
// equipment info action. Once that happens, 
// it clears the values of the form fields.
// const ClearFormValues = ({compState, dispatch}) => {
//   const { setFieldValue } = useFormikContext();

//   useEffect(() => {
//     if (compState.clearFormValues === true) {
//       setFieldValue("skillId", "")
//       setFieldValue("equipmentName", "")
//       setFieldValue("equipmentUnits", "")
//       setFieldValue("remark", "")
//       dispatch({type: 'reset', body: {}})
//     } 
//   }, [compState.clearFormValues])
  
//   return null;
// }

const SectionFive = ({ dataSubmitTrigger, setEquipmentAdded }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  const globalDispatch = useDispatch();
  const trainingCentreRegReducer = (globalState) =>
    globalState.trainingCentreRegReducer;

  const { equipments } = useSelector(trainingCentreRegReducer);

  const contextObject = useContext(TrainingCentreRegContext);

  // use effects
  useEffect(() => {
    dispatch({
      type: "syncLocalStore",
      body: {
        equipments,
      },
    });
  }, []);

  useEffect(() => {
    
    if (state.equipments.length < 1) {
      setEquipmentAdded(false)
    }

  }, [state.equipments])
  

  useEffect(() => {
    if (dataSubmitTrigger === true) {
      globalDispatch(saveFormDataPartTwo({
        equipments: [
          ...equipments,
          ...state.equipments
        ]
      }));
    }
  }, [dataSubmitTrigger]);

  // me: refactor this oooo
  // me 1 week later: but how bro?
  let newOptions = [];
  contextObject.parsedListOfSkills.map((skill) => {
    newOptions.push({
      value: skill.id,
      label: skill.label,
    });
  });

  function handleUserActions(type, body) {
    dispatch({
      type: type,
      body: body,
    });
  }

  function handleFormSubmit(values, actions) {
    handleUserActions("addedTrainingEquipmentInfo", values);
    setEquipmentAdded(true)
    actions.resetForm();
  }

  // Markups
  const trainingEquipmentFormMarkup = [
    [
      {
        type: "singleSelect",
        label: "Skill Area*",
        name: "skillId",
        options: newOptions,
      },
      {
        type: "textField",
        label: "Equipment Name*",
        name: "equipmentName",
      },
    ],
    [
      {
        type: "textField",
        label: "Total Number Available*",
        name: "equipmentUnits",
      },
      {
        type: "textField",
        label: "Remarks*",
        name: "remark",
      },
    ],
  ];

  // Datatable Configs
  const trainingEquipmentTableColumns = [
    {
      name: "skillId",
      label: "Skill Area",
      options: {
        customBodyRender: (value) => {
          const skillName = contextObject.parsedListOfSkills.find(
            (skill) => skill.id === value
          )?.label;
          return skillName;
        },
      },
    },
    {
      name: "equipmentName",
      label: "Equipment Name   ",
      // options: {}
    },
    {
      name: "equipmentUnits",
      label: "Total Number Available",
      // options: {}
    },
    {
      name: "remark",
      label: "Remarks",
      // options: {}
    },
    {
      name: "actions",
      label: "Actions",
      options: {
        customBodyRender: (value, tableMeta) => {
          return (
            <Button
              variant="outlined"
              size="small"
              sx={{
                color: "red",
                border: "0.5px solid red",
              }}
              onClick={() =>
                handleUserActions(
                  "deletedTrainingEquipmentInfo",
                  tableMeta.rowIndex
                )
              }
            >
              Delete
            </Button>
          );
        },
      },
    },
  ];

  const trainingEquipmentTableOptions = {};

  return (
    <Formik
      initialValues={{
        ...INITIAL_STATE,
      }}
      validationSchema={formValidationSchema}
      onSubmit={handleFormSubmit}
    >
      <Form>
        <Grid
          container
          item
          xs
          // style={{ paddingTop: "2rem" }}
          direction={"column"}
          gap={"2rem"}
        >
          <Grid item xs style={{ paddingTop: "2rem" }}>
            <h2>Section 5</h2>
            <p>Assessment of Training Equipment</p>
          </Grid>

          <Grid
            item
            xs
            container
            direction={"column"}
            style={{
              border: "1px solid lightgrey",
              borderRadius: "7px",
              padding: "1rem",
              // marginTop: "2rem",
            }}
          >
            <h3>Training Equipment Form</h3>
            {trainingEquipmentFormMarkup.map((row, index) => (
              <Grid item container xs key={index} gap="2rem">
                {row.map((field, index) => (
                  <Grid item xs key={index}>
                    {field.type === "singleSelect" && (
                      <SelectTR
                        name={field.name}
                        label={field.label}
                        options={field.options}
                      />
                    )}

                    {field.type === "textField" && (
                      <TextFieldTR label={field.label} name={field.name} />
                    )}
                  </Grid>
                ))}
              </Grid>
            ))}
            <Grid
              item
              xs
              style={{
                flexGrow: 0,
                paddingTop: "2.5rem",
              }}
            >
              <ButtonTR variant="contained">Add Training Equipment</ButtonTR>
            </Grid>
          </Grid>

          <MUIDataTable
            columns={trainingEquipmentTableColumns}
            options={trainingEquipmentTableOptions}
            data={state.equipments}
            title={"Training Equipments"}
          />
          {/* <ClearFormValues compState={state} dispatch={dispatch} /> */}
        </Grid>
      </Form>
    </Formik>
  );
};

export default SectionFive;
